import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-star-cross",
  "use": "icon-si-glyph-star-cross-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-star-cross\" id=\"icon-si-glyph-star-cross\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>107</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M9.601,6.4 L8,0 L6.398,6.4 L0,8 L6.398,9.601 L8,16 L9.601,9.601 L16,8 L9.601,6.4 L9.601,6.4 Z M8,9.334 C7.264,9.334 6.668,8.736 6.668,8 C6.668,7.264 7.264,6.667 8,6.667 C8.736,6.667 9.333,7.264 9.333,8 C9.333,8.736 8.736,9.334 8,9.334 L8,9.334 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-star-cross.svg
// module id = er86
// module chunks = 62